import { experimentSettings } from "@/constants/experiments";
import { hasSettingEqualTo } from "@/helpers/experiment-helper";

const LOCATION_API_V1 = "/location/api/v1/";
const LOCATION_API_V2 = "/location/api/v2/";

export function useCoreServicesLocationService(experimentSettingsMap) {
    return hasSettingEqualTo(
        experimentSettings.USER_CORE_SERVICES_LOCATION_SERVICE,
        "true",
        experimentSettingsMap
    );
}

export function resolveLocationApiUrl(url, experimentSettingsMap = {}) {
    if (!url?.includes("/location/api/")) {
        return url;
    }

    const useV2 = useCoreServicesLocationService(experimentSettingsMap);
    if (useV2) {
        return url.replace(LOCATION_API_V1, LOCATION_API_V2);
    }
    return url.replace(LOCATION_API_V2, LOCATION_API_V1);
}
